exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.currency_button {\n  display: flex;\n  justify-content: center;\n}\n.determine {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.cancel {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14be3eaa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/page/train/newservice/SpecialCourses.vue
// module id = 1643
// module chunks = 0